import Vue from 'vue'

import _Object$keys from 'babel-runtime/core-js/object/keys';
export default function directive(Vue) {
  // 指令不能用于虚拟dom，且和v-if同时使用时，判断层级要高于v-if
  // 根据权限是否展示操作按钮
  Vue.directive('auth', {
    inserted: function inserted(el, binding) {
      if (!binding.value.meta) {
        // 兼容ie的和chrome的各种写法
        var _parentElement = el.parentNode;
        if (_parentElement) {
          _parentElement.removeChild(el);
        }
      } else {
        var keys = _Object$keys(binding.value.meta);
        if (keys.indexOf(binding.value.btn) === -1) {
          // 兼容ie的和chrome的各种写法
          var _parentElement = el.parentNode;
          if (_parentElement) {
            _parentElement.removeChild(el);
          }
        }
      }
    }
  });

  // 根据权限头部筛选是否隐藏
  Vue.directive('hideQuerys', {
    inserted: function inserted(el, binding) {
      if (!binding.value.hideQuerys) return false;
      var keys = _Object$keys(binding.value.hideQuerys);
      if (keys.indexOf(binding.value.query) !== -1) {
        var _parentElement = el.parentNode;
        if (_parentElement) {
          _parentElement.removeChild(el);
        }
      }
    }
  });

  //=============
  //防止多次连续点击提交
  Vue.directive('preventReClick', {
    inserted(el, binding) {
      el.addEventListener('click', () => {
        if (!el.disabled) {
          el.disabled = true
          setTimeout(() => {
            el.disabled = false
          }, binding.value || 2000)
        }
      })
    }
  })

  //获取焦点
  Vue.directive('focus', {
    // 当被绑定的元素插入到 DOM 中时……
    inserted: function (el) {
      // 聚焦元素
      el.focus()
    }
  })

  //超出省略展示提示文案
  Vue.directive("ellipsis", {
    inserted(el, bindings) {
      bindEvent(el, bindings);
    },
    componentUpdated(el, bindings) {
      bindEvent(el, bindings);
    },
    unbind() {
      removeTooltip();
    },
  });


}

//========================== v-ellipsis 超出省略展示提示文案
let tooltipDom;
function bindEvent(el, bindings) {
  // 先移除上一次绑定的事件
  el.removeEventListener("mouseenter", handleMouseEnter);
  el.removeEventListener("mouseleave", removeTooltip);

  if (bindings.value === false) {
    return;
  }
  // 给当前元素设置超出隐藏
  el.style.overflow = "hidden";
  el.style.textOverflow = "ellipsis";
  el.style.whiteSpace = "nowrap";

  // 如果超出，绑定鼠标移入移出事件
  if (el.scrollWidth > el.offsetWidth) {
    el.addEventListener("mouseenter", handleMouseEnter);
    // 鼠标移出 将提示信息移除
    el.addEventListener("mouseleave", removeTooltip);
  }
}

/** 鼠标移入事件 */
function handleMouseEnter(e) {
  if (!tooltipDom) {
    // 创建浮层元素
    tooltipDom = document.createElement("div");
    // 将浮层插入到body中
    document.body.appendChild(tooltipDom);
  }
  const maxWidth = 600;
  let cssText = `
          max-width: ${maxWidth}px;
          overflow: auto;
          position: fixed;
          background: #262627;
          color: #fff;
          border-radius: 4px;
          line-height: 22px;
          padding: 10px;
          display: block;
          font-size: 16px;
          z-index: 99999;
          word-break: break-all;
        `;
  // 根据鼠标移入位置判断浮层位于左侧还是右侧，避免遮挡
  if (window.innerWidth - e.clientX < maxWidth) {
    cssText += `right:${window.innerWidth - e.clientX}px;`;
  } else {
    cssText += `left:${e.clientX + 20}px;`;
  }
  // 根据鼠标移入位置判断浮层位于上方还是下方，避免遮挡
  if (window.innerHeight - e.clientY < 600) {
    cssText += `bottom:${window.innerHeight - e.clientY}px;`;
  } else {
    cssText += `top:${e.clientY}px;`;
  }

  tooltipDom.className = "custom_tooltip"
  tooltipDom.style.cssText = cssText;
  // 浮层中的文字
  tooltipDom.innerHTML = e.currentTarget.innerHTML;
}

function removeTooltip() {
  // 隐藏浮层
  if (tooltipDom) {
    tooltipDom.style.display = "none";
  }
}





//////////////////
// WEBPACK FOOTER
// ../vue-common-laboratory/dist/utils/directive.js
// module id = 6k4+
// module chunks = 115